import { useCallback, useMemo, useState } from "react";
import { AppTester } from "supporting";
import useQueryState from "./useQueryState";
import { useRouteMatch } from "react-router-dom";
import { LinkTo } from "../constants/linkTo";

//todo organize globaltype conditions

const useExtraFilter = (disabled?: boolean): [any, (filter: any) => void] => {
  const [{ teachersOnly, studentOnly }, setQueryParams] = useQueryState();
  const isHSEDesign = AppTester.isHSEDesign() && !AppTester.isHseSpace();
  const isProHSE = AppTester.isProHSE();
  const isStartHSE = AppTester.isStartHSE();
  const shouldSendGlobalType = (useRouteMatch(['/:data', '/', '/teams/hselab', '/teams/sound'])?.isExact && !isStartHSE) || !disabled
  const isAlumni = !!useRouteMatch(LinkTo.alumni)
  //todo разобраться, откуда берутся лишние глобалтайпы и убрать хардкод
  const isTeachersTech = !!useRouteMatch('/teacherstech')

  const defaultGlobalTypes = isAlumni ? ['hsealumni'] : (shouldSendGlobalType) && isHSEDesign ? ['student', 'hsealumni'] : [];

  const globalTypeFilter = isHSEDesign && !isProHSE ? {
    globalTypes: teachersOnly === 'true' || isTeachersTech ? ['employee', 'cooperator'] : defaultGlobalTypes,
  } : {};


  const [extraFilter, setExtraFilter] = useState({ 
    ...globalTypeFilter,
  });

  // @ts-ignore
  const onExtraFilterChange = useCallback((filter) => {
      setExtraFilter({
        ...extraFilter,
        ...filter,
      })
    //todo разобраться, как это теперь работает без setDate()
  }, [setExtraFilter, extraFilter])

  const extraFilterFinal = useMemo(() => ({
    ...extraFilter,
    ...globalTypeFilter,
}), [extraFilter, teachersOnly, globalTypeFilter]);

  return [extraFilterFinal, onExtraFilterChange];
}

export default useExtraFilter;import { useCallback, useMemo, useState } from "react";
import { AppTester } from "supporting";
import useQueryState from "./useQueryState";
import { useRouteMatch } from "react-router-dom";
import { LinkTo } from "../constants/linkTo";

//todo organize globaltype conditions

const useExtraFilter = (disabled?: boolean): [any, (filter: any) => void] => {
  const [{ teachersOnly, studentOnly }, setQueryParams] = useQueryState();
  const isHSEDesign = AppTester.isHSEDesign() && !AppTester.isHseSpace();
  const isProHSE = AppTester.isProHSE();
  const isStartHSE = AppTester.isStartHSE();
  const shouldSendGlobalType = (useRouteMatch(['/:data', '/', '/teams/hselab', '/teams/sound'])?.isExact && !isStartHSE) || !disabled
  const isAlumni = !!useRouteMatch(LinkTo.alumni)
  //todo разобраться, откуда берутся лишние глобалтайпы и убрать хардкод
  const isTeachersTech = !!useRouteMatch('/teacherstech')

  const defaultGlobalTypes = isAlumni ? ['hsealumni'] : (shouldSendGlobalType) && isHSEDesign ? ['student', 'hsealumni'] : [];

  const globalTypeFilter = isHSEDesign && !isProHSE ? {
    globalTypes: teachersOnly === 'true' || isTeachersTech ? ['employee', 'cooperator'] : defaultGlobalTypes,
  } : {};


  const [extraFilter, setExtraFilter] = useState({ 
    ...globalTypeFilter,
  });

  // @ts-ignore
  const onExtraFilterChange = useCallback((filter) => {
      setExtraFilter({
        ...extraFilter,
        ...filter,
      })
    //todo разобраться, как это теперь работает без setDate()
  }, [setExtraFilter, extraFilter])

  const extraFilterFinal = useMemo(() => ({
    ...extraFilter,
    ...globalTypeFilter,
}), [extraFilter, teachersOnly, globalTypeFilter]);

  return [extraFilterFinal, onExtraFilterChange];
}

export default useExtraFilter;